// THIS FILE IS AUTO GENERATED
// ANY CHANGES WILL BE LOST DURING BUILD
// MODIFY THE .SCSS FILE INSTEAD

import { css, CSSResult } from 'lit';
/**
 * exports lit-element css
 * @export styles
 */
export const styles: CSSResult[] = [
  css`

`];